import { LocalData } from "../General/LocalData";
import { RoutineData } from "./RoutineData";
import { CollectionLoadedListener } from "../General/CollectionLoader";
import { ArrayUtilities } from "../../../utils/arrayUtilities";
import { query, where } from "firebase/firestore";

export class RoutinesLoader {
  loadedRoutines = false;

  loadRoutines(onFinish: () => void) {
    let companies: string[][] = ArrayUtilities.arrayToMultiDimensional(
      LocalData.currentUser.companies.map((c) => c.id),
      10
    );
    let contractorGroups: string[][] = ArrayUtilities.arrayToMultiDimensional(
      LocalData.currentUser.contractorGroups.map((c) => c.id),
      10
    );

    const totalLoadCount = companies.length + contractorGroups.length + 1;
    let totalLoaded = 0;

    const loaded = () => {
      totalLoaded++;
      if (totalLoaded >= totalLoadCount) {
        this.loadedRoutines = true;

        onFinish();
      }
    };

    for (const companiesArray of companies) {
      if (companiesArray.length === 0) continue;
      LocalData.routines.setupRealtimeListenerWithFilter(
        (ref) => query(ref, where("companies", "array-contains-any", companiesArray)),
        () => {
          loaded();
        }
      );
    }
    for (const contractorGroupArray of contractorGroups) {
      if (contractorGroupArray.length === 0) continue;
      LocalData.routines.setupRealtimeListenerWithFilter(
        (ref) => query(ref, where("contractorGroups", "array-contains-any", contractorGroupArray)),
        () => {
          loaded();
        }
      );
    }

    LocalData.routines.setupRealtimeListenerWithFilter(
      (ref) => query(ref, where("createdBy.userID", "==", LocalData.currentUser.id)),
      () => {
        loaded();
      }
    );
  }

  setupRoutinesListener(onRefresh: () => void) {
    const listener = new RoutinesLoaderListener(onRefresh);
    const listeners: CollectionLoadedListener<RoutineData>[] = [];
    let companies: string[][] = ArrayUtilities.arrayToMultiDimensional(
      LocalData.currentUser.companies.map((c) => c.id),
      10
    );
    let contractorGroups: string[][] = ArrayUtilities.arrayToMultiDimensional(
      LocalData.currentUser.contractorGroups.map((c) => c.id),
      10
    );

    listener.totalLoadCount = companies.length + contractorGroups.length + 1;

    for (const companiesArray of companies) {
      if (companiesArray.length === 0) continue;
      listeners.push(
        LocalData.routines.setupRealtimeListenerWithFilter(
          (ref) => query(ref, where("companies", "array-contains-any", companiesArray)),
          () => {
            listener.loadedCount++;
            listener.runAfterLoaded();
          }
        )
      );
    }
    for (const contractorGroupArray of contractorGroups) {
      if (contractorGroupArray.length === 0) continue;
      listeners.push(
        LocalData.routines.setupRealtimeListenerWithFilter(
          (ref) => query(ref, where("contractorGroups", "array-contains-any", contractorGroupArray)),
          () => {
            listener.loadedCount++;
            listener.runAfterLoaded();
          }
        )
      );
    }

    listeners.push(
      LocalData.routines.setupRealtimeListenerWithFilter(
        (ref) => query(ref, where("createdBy.userID", "==", LocalData.currentUser.id)),
        () => {
          listener.loadedCount++;
          listener.runAfterLoaded();
        }
      )
    );

    listener.listeners = listeners;
    return listener;
  }
}

export class RoutinesLoaderListener {
  listeners: CollectionLoadedListener<RoutineData>[] = [];
  loadedCount = 0;
  totalLoadCount = 0;

  handleRefresh: () => void;
  constructor(handleRefresh: () => void) {
    this.handleRefresh = handleRefresh;
  }

  isLoaded() {
    return this.loadedCount >= this.totalLoadCount;
  }

  runAfterLoaded() {
    if (this.loadedCount >= this.totalLoadCount) {
      console.log("Loaded all routines");
      this.handleRefresh();
    }
  }
  removeAllListeners() {
    for (const listener of this.listeners) {
      listener.removeListener();
    }
    this.listeners = [];
  }
}

